import { render, staticRenderFns } from "./KnowledgeBaseDetail.vue?vue&type=template&id=6ccea84b"
import script from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports